// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventoryHistory_container__vOrj- {
  height: 100%;
  min-height: 390px; }
  .inventoryHistory_container__vOrj- .inventoryHistory_history__Uouv\\+ {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: calc(100% - 20px); }
    .inventoryHistory_container__vOrj- .inventoryHistory_history_title__5F9Ab {
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      color: var(--HightEmphasis);
      letter-spacing: 0.1px; }
  .inventoryHistory_container__vOrj- .inventoryHistory_historyItems__WzK-q .inventoryHistory_item__72Phj {
    display: flex;
    margin-top: 10px;
    cursor: pointer; }
  .inventoryHistory_container__vOrj- .inventoryHistory_historyItems__WzK-q .inventoryHistory_status__FufqV {
    margin-left: 10px; }
  .inventoryHistory_container__vOrj- #inventoryHistory_d3Test__0Bckj {
    width: 100%;
    margin-top: 50px; }
  .inventoryHistory_container__vOrj- .inventoryHistory_noItem__UQQn9 {
    width: 100%;
    height: 370px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: -40px; }
    .inventoryHistory_container__vOrj- .inventoryHistory_noItem__UQQn9 h2 {
      font-weight: 700;
      font-size: 18px;
      line-height: 150%;
      margin-bottom: 11px; }
    .inventoryHistory_container__vOrj- .inventoryHistory_noItem__UQQn9 p {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #666666; }

.inventoryHistory_buttonWhite__LSbN0 {
  background: #e0e0e0;
  padding: 8px 12px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.5s; }
  .inventoryHistory_buttonWhite__LSbN0:hover {
    background: #f3e0e0; }

.inventoryHistory_algorithmsFilterContainer__Kg1Sn {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around; }

.inventoryHistory_algorithmRadioContainer__H5var {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  align-items: flex-start;
  justify-content: center; }
  .inventoryHistory_algorithmRadioContainer__H5var div {
    margin-bottom: 0 !important; }

.inventoryHistory_stockData__mJkKF, .inventoryHistory_stockIn__xjrVH, .inventoryHistory_low__FeIIB, .inventoryHistory_out__OhLdD {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  border-radius: 11px;
  min-width: 84px;
  max-width: 128px;
  color: var(--White);
  font-size: 12px; }

.inventoryHistory_stockIn__xjrVH {
  background-color: var(--Green); }

.inventoryHistory_low__FeIIB {
  background-color: var(--StockOrange); }

.inventoryHistory_out__OhLdD {
  background-color: var(--StockRed); }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/InventoryHistory/inventoryHistory.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,iBAAiB,EAAA;EAFnB;IAII,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB,EAAA;IAT5B;MC4BE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDlBb,2BAA2B;MAC3B,qBAAqB,EAAA;EAb3B;IAmBM,aAAa;IACb,gBAAgB;IAChB,eAAe,EAAA;EArBrB;IAwBM,iBAAiB,EAAA;EAxBvB;IA6BI,WAAW;IACX,gBAAgB,EAAA;EA9BpB;IAiCI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB,EAAA;IAvCrB;MAyCM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,mBAAmB,EAAA;IA5CzB;MA+CM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA;;AAIpB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB,EAAA;EANtB;IAQI,mBAAmB,EAAA;;AAIvB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B,EAAA;;AAG/B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,uBAAuB,EAAA;EANzB;IAQI,2BAA0B,EAAA;;AAI9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe,EAAA;;AAEf;EACE,8BAA8B,EAAA;;AAIhC;EACE,oCAAoC,EAAA;;AAItC;EACE,iCAAiC,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.container {\n  height: 100%;\n  min-height: 390px;\n  .history {\n    margin-top: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    width: calc(100% - 20px);\n    &_title {\n      @include h6;\n      color: var(--HightEmphasis);\n      letter-spacing: 0.1px;\n    }\n  }\n\n  .historyItems {\n    .item {\n      display: flex;\n      margin-top: 10px;\n      cursor: pointer;\n    }\n    .status {\n      margin-left: 10px;\n    }\n  }\n\n  #d3Test {\n    width: 100%;\n    margin-top: 50px;\n  }\n  .noItem {\n    width: 100%;\n    height: 370px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    margin-top: -40px;\n    h2 {\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 150%;\n      margin-bottom: 11px;\n    }\n    p {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      color: #666666;\n    }\n  }\n}\n.buttonWhite{\n  background: #e0e0e0;\n  padding: 8px 12px;\n  border-radius: 16px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.5s;\n  &:hover {\n    background: #f3e0e0;\n  }\n}\n\n.algorithmsFilterContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.algorithmRadioContainer {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: row;\n  column-gap: 4px;\n  align-items: flex-start;\n  justify-content: center;\n  div{\n    margin-bottom: 0!important;\n  }\n}\n\n.stockData {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  border-radius: 11px;\n  min-width: 84px;\n  max-width: 128px;\n  color: var(--White);\n  font-size: 12px;\n}\n  .stockIn {\n    background-color: var(--Green);\n    @extend .stockData\n  }\n\n  .low {\n    background-color: var(--StockOrange);\n    @extend .stockData\n  }\n\n  .out {\n    background-color: var(--StockRed);\n    @extend .stockData\n  }\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `inventoryHistory_container__vOrj-`,
	"history": `inventoryHistory_history__Uouv+`,
	"history_title": `inventoryHistory_history_title__5F9Ab`,
	"historyItems": `inventoryHistory_historyItems__WzK-q`,
	"item": `inventoryHistory_item__72Phj`,
	"status": `inventoryHistory_status__FufqV`,
	"d3Test": `inventoryHistory_d3Test__0Bckj`,
	"noItem": `inventoryHistory_noItem__UQQn9`,
	"buttonWhite": `inventoryHistory_buttonWhite__LSbN0`,
	"algorithmsFilterContainer": `inventoryHistory_algorithmsFilterContainer__Kg1Sn`,
	"algorithmRadioContainer": `inventoryHistory_algorithmRadioContainer__H5var`,
	"stockData": `inventoryHistory_stockData__mJkKF`,
	"stockIn": `inventoryHistory_stockIn__xjrVH`,
	"low": `inventoryHistory_low__FeIIB`,
	"out": `inventoryHistory_out__OhLdD`
};
export default ___CSS_LOADER_EXPORT___;
